import React from 'react'
import CameraScanModal from './CameraScanModal'

/**
 * HOC that provides camera scan modal functionality
 */
export const withCameraScanModal = (Component) => {
  return class CameraScanModalWrapper extends React.Component {
    state = {
      isShow: false,
      onScanSuccess: null,
    }

    handleShowModal = (onScanSuccess) => {
      this.setState({
        isShow: true,
        onScanSuccess: onScanSuccess || null,
      })
    }

    handleHide = () => {
      this.setState({
        isShow: false,
        onScanSuccess: null,
      })
    }

    handleScanSuccess = (barcode) => {
      if (this.state.onScanSuccess) {
        this.state.onScanSuccess(barcode)
      }
      this.handleHide()
    }

    render() {
      return (
        <div>
          <Component
            {...this.props}
            isCameraScanModalShow={this.state.isShow}
            showCameraScanModal={this.handleShowModal}
            hideCameraScanModal={this.handleHide}
          />

          <CameraScanModal
            show={this.state.isShow}
            onScanSuccess={this.handleScanSuccess}
            onCancel={this.handleHide}
          />
        </div>
      )
    }
  }
}
